<div class="create-wf-flex">
    <button class="scraii-primary-btn create-wf-dropdown-btn" [matMenuTriggerFor]="createWfMenu">
        Create Workflow
        <mat-icon class="create-wf-dropdown-icon">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #createWfMenu="matMenu" class="create-wf-menu">
        <button mat-menu-item (click)="addWorkFlow('trigger')">
            <!-- <mat-icon>flash_on</mat-icon> -->
            <span>Trigger Workflow</span>
        </button>
        <button mat-menu-item (click)="addWorkFlow('schedule')">
            <!-- <mat-icon>schedule</mat-icon> -->
            <span>Schedule Workflow</span>
        </button>
    </mat-menu>
</div>

<div class="workflow-card" id="wf_management_id">
    <!-- Header -->
    <div class="workflow-card-header">
        <h2 class="workflow-card-title">Workflow List</h2>
        <div class="workflow-card-actions">
            <!-- Search Input -->
            <div class="workflow-search-wrapper">
                <input type="text" class="workflow-search-input" placeholder="Search by..." [(ngModel)]="searchText"
                    (ngModelChange)="onSearchChange()" />
                <svg class="workflow-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
            </div>
            <!-- Filter By Dropdown -->
            <mat-form-field appearance="outline" class="workflow-filter-field">
                <!-- <mat-label>Filter By</mat-label> -->
                <mat-select [(ngModel)]="selectedFilter" (ngModelChange)="onFilterChange()">
                    <mat-option value="">All</mat-option>
                    <mat-option value="schedule">Schedule</mat-option>
                    <mat-option value="event">Event</mat-option>
                    <mat-option value="manual">Manual</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Brand Dropdown — same UX as task-management-wf. The selected
                 brand is forwarded to the workflow designer via query params
                 and powers the email-template lookup in Email Alert steps. -->
            <div class="wfm-brand-dropdown-wrapper">
                <button class="wfm-brand-dropdown-btn" [class.open]="brandDropdownOpen"
                    (click)="toggleBrandDropdown($event)">
                    <span class="wfm-brand-btn-label">{{ selectedBrand?.brand_name || 'Select Brand' }}</span>
                    <mat-icon class="wfm-brand-btn-arrow">{{ brandDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>

                <div class="wfm-brand-dropdown-panel" *ngIf="brandDropdownOpen" (click)="$event.stopPropagation()">
                    <div class="wfm-brand-search-wrap">
                        <input class="wfm-brand-search-input" type="text" placeholder="Search..."
                            autocomplete="off" [ngModel]="brandSearchText"
                            (ngModelChange)="onBrandSearch($event)" />
                    </div>

                    <div *ngIf="isLoadingBrands" class="wfm-brand-loading">
                        <mat-spinner diameter="16"></mat-spinner>
                        <span>Loading...</span>
                    </div>

                    <div class="wfm-brand-list" *ngIf="!isLoadingBrands">
                        <div *ngIf="filteredBrands.length === 0" class="wfm-brand-empty">No brands found</div>
                        <div *ngFor="let brand of filteredBrands" class="wfm-brand-item"
                            [class.selected]="selectedBrand?.brand_key === brand.brand_key"
                            (click)="selectBrand(brand)">
                            <div class="wfm-brand-checkbox"
                                [class.checked]="selectedBrand?.brand_key === brand.brand_key">
                                <mat-icon *ngIf="selectedBrand?.brand_key === brand.brand_key"
                                    class="wfm-brand-check-icon">check</mat-icon>
                            </div>
                            <span class="wfm-brand-item-name">{{ brand.brand_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- AG Grid -->
    <div class="workflow-grid-container">
        <ag-grid-angular style="width: 100%; font-family: 'Poppins';" class="ag-theme-balham workflow-grid"
            [suppressCellFocus]="true" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
            [rowData]="filteredRowData" (gridReady)="onGridReady($event)" [rowSelection]="rowSelection"
            [pagination]="true" [paginationPageSize]="paginationPageSize" [suppressPaginationPanel]="true"
            [rowHeight]="52" [headerHeight]="48" [domLayout]="'autoHeight'" [rowStyle]="rowStyle"
            (rowClicked)="onRowClicked($event)" (cellClicked)="onGridCellClicked($event)"
            (paginationChanged)="onPaginationChanged()">
        </ag-grid-angular>
        <div *ngIf="isLoadingDefs" class="workflow-grid-loader">
            <loading></loading>
        </div>
    </div>

    <!-- Custom Pagination Footer -->
    <div class="workflow-pagination-footer">
        <div class="workflow-pagination-left">
            <span class="workflow-pagination-label">Rows per page</span>
            <mat-form-field appearance="outline" class="workflow-page-size-field">
                <mat-select [(ngModel)]="paginationPageSize" (ngModelChange)="onPageSizeChange($event)">
                    <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="workflow-pagination-right">
            <button class="workflow-page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <ng-container *ngFor="let page of visiblePages">
                <span *ngIf="page === '...'" class="workflow-page-ellipsis">...</span>
                <button *ngIf="page !== '...'" class="workflow-page-num"
                    [class.workflow-page-active]="page === currentPage + 1" (click)="goToPage(+page - 1)">
                    {{ page }}
                </button>
            </ng-container>
            <button class="workflow-page-btn" [disabled]="currentPage >= totalPages - 1"
                (click)="goToPage(currentPage + 1)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
            </button>
        </div>
    </div>
</div>